export default "__VITE_ASSET__BhHP09AM__"